// extracted by mini-css-extract-plugin
export var btn = "D_mD x_ss x_sf d_bw d_bL d_bz d_ds";
export var full = "D_t7 d_s d_D";